// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.interested-course {
    margin: 0;
    padding: 0;
    padding: 10px;
}

.students-interested-course {
    margin-inline-end: 10px;
    display: flex;
}

.interested-course-form {
    max-inline-size: 100%;
    margin: 0px auto;
    padding: 10px;
    background-color: #f5f5f5;
    border-radius: 10px;
    border: 2px solid black;
    color: #0e0e0e;
    font-weight: 400;
    margin-block-start: 20px;
    font-size: 1.2rem;
}

.interested-course-label {
    margin-block-end: 10px;
    color: #0e0e0e;
    font-weight: 400;
    font-size: 1.4rem;
}

.interested-course-1 {
    inline-size: 100%;
    padding: 8px;
    margin-block-end: 4px;
    border: 1px solid #ccc;
    border-radius: 4px;
}

.interested-course-submit {
    inline-size: 100%;
    padding: 4px;
    background: linear-gradient(135deg, #052659, #5483B3);
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 20px;
}

.recommendations-container {
    margin-block-start: 20px;
    background: linear-gradient(45deg, #3868a3, #21629a, #6a91ae);
    border: 1px solid #020202;
    overflow-y: auto;
    max-block-size: auto;
    inline-size: auto;
    border-radius: 10px;
}

.recommendations-index {
    margin-block-end: 10px;
    margin-inline-start: 20px;
    margin-block-start: 20px;
    color: white;
    font-weight: 600;
    font-size: 1.8rem;
}

.recommendations-ul {
    list-style-type: none;
    padding: 0;
}

.recommendations-ul a {
    color: white;
    text-decoration: none;
}

.recommendations-ul a:hover {
    color: rgb(0, 0, 0);
}

.recommendations-li {
    margin-block-end: 8px;
    font-weight: 400;
    font-size: 25px;
    text-align: start;
    margin-inline-start: 10px;
    margin-block-start: 10px;
    padding: 2px;
}

.recommendations-index-flex {
    display: flex;
    align-items: center;
}

.jNeOpF1 {
    -webkit-box-align: center;
    align-items: center;
    background-color: rgb(255, 255, 255);
    border: 1px solid rgb(32, 226, 215);
    border-radius: 50%;
    display: flex;
    block-size: 25px;
    font-size: 1.0rem;
    -webkit-box-pack: center;
    justify-content: center;
    inline-size: 25px;
    margin-block-end: 20px;
}

.lfeMSB1 {
    -webkit-box-align: center;
    align-items: center;
    background-color: rgb(255, 255, 255);
    border: 1px solid rgb(32, 226, 215);
    border-radius: 50%;
    display: flex;
    block-size: 25px;
    font-size: 1.4rem;
    -webkit-box-pack: center;
    justify-content: center;
    inline-size: 25px;
}

.lfem1 {
    margin-block-end: 20px;
}

.lfems1 {
    margin-block-end: 20px;
}

.lfems2 {
    margin-block-end: 20px;
    margin-block-start: 10px;
}

.iZEyIQ1 ul li::after {
    background-color: rgb(204, 204, 204);
    content: " ";
    block-size: 20px;
    inset-inline-start: calc((45% - 1px));
    position: absolute;
    inset-block-start: 25px;
    inline-size: 3px;
}

.iZEyIQ1 ul li {
    position: relative;
}

.Circle-sc-fvyqwls-1 {
    font-size: 20px;
    margin-block-start: 0px;
    list-style: none;
    gap: 40px;
    margin-block-start: 0px;
}

@media (max-width: 480px) {
    .students-interested-course {
        flex-direction: column;
        margin-inline-end: 10px;
    }
    .interested-course-form {
        max-inline-size: 90%;
        border-radius: 0px;
        margin-block-start: 20px;
    }
    .interested-course-1 {
        inline-size: 100%;
        border-radius: 0px;
    }
    .recommendations-container {
        inline-size: 90%;
        border-radius: 0px;
        margin-inline-start: 14px;
    }
    .recommendations-index {
        margin-block-end: 10px;
        margin-inline-start: 10px;
        margin-block-start: 20px;
        font-size: 1.4rem;
    }
    .recommendations-li {
        font-size: 1.2rem;
        margin-inline-start: -20px;
    }
    .recommendations-index-flex {
        display: flex;
        align-items: start;
    }
    .jNeOpF1 {
        -webkit-box-align: center;
        align-items: center;
        background-color: rgb(255, 255, 255);
        border: 0px solid rgb(32, 226, 215);
        border-radius: 0%;
        display: flex;
        block-size: 0px;
        font-size: 0rem;
        -webkit-box-pack: center;
        justify-content: center;
        inline-size: 0px;
        margin-block-end: 0px;
    }
    .lfeMSB1 {
        -webkit-box-align: center;
        align-items: center;
        background-color: rgb(255, 255, 255);
        border: 0px solid rgb(32, 226, 215);
        border-radius: 0%;
        display: flex;
        block-size: 0px;
        font-size: 0rem;
        -webkit-box-pack: center;
        justify-content: center;
        inline-size: 0px;
    }
    .lfem1 {
        margin-block-end: 0px;
    }
    .lfems1 {
        margin-block-end: 0px;
    }
    .lfems2 {
        margin-block-end: 0px;
        margin-block-start: 0px;
    }
    .iZEyIQ1 ul li::after {
        background-color: rgb(204, 204, 204);
        content: " ";
        block-size: 0px;
        inset-inline-start: calc((0% - 0px));
        position: absolute;
        inset-block-start: 0px;
        inline-size: 0px;
    }
    .iZEyIQ1 ul li {
        position: relative;
    }
    .Circle-sc-fvyqwls-1 {
        font-size: 0px;
        margin-block-start: 0px;
        list-style: none;
        gap: 0px;
        margin-block-start: 0px;
    }
}


/* Tablet Styling */

@media (min-width: 481px) and (max-width: 1023px),
(min-width : 768px) and (max-width : 1023px),
(min-width : 1024px) and (max-width : 1279px) {
    .students-interested-course {
        margin-right : 10px;
        flex-direction: column;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/data.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,qBAAqB;IACrB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,qDAAqD;IACrD,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,6DAA6D;IAC7D,yBAAyB;IACzB,gBAAgB;IAChB,oBAAoB;IACpB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,wBAAwB;IACxB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,wBAAwB;IACxB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,oCAAoC;IACpC,mCAAmC;IACnC,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,wBAAwB;IACxB,uBAAuB;IACvB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,oCAAoC;IACpC,mCAAmC;IACnC,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,wBAAwB;IACxB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,wBAAwB;AAC5B;;AAEA;IACI,oCAAoC;IACpC,YAAY;IACZ,gBAAgB;IAChB,qCAAqC;IACrC,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,gBAAgB;IAChB,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;IACA;QACI,oBAAoB;QACpB,kBAAkB;QAClB,wBAAwB;IAC5B;IACA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;IACA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,yBAAyB;IAC7B;IACA;QACI,sBAAsB;QACtB,yBAAyB;QACzB,wBAAwB;QACxB,iBAAiB;IACrB;IACA;QACI,iBAAiB;QACjB,0BAA0B;IAC9B;IACA;QACI,aAAa;QACb,kBAAkB;IACtB;IACA;QACI,yBAAyB;QACzB,mBAAmB;QACnB,oCAAoC;QACpC,mCAAmC;QACnC,iBAAiB;QACjB,aAAa;QACb,eAAe;QACf,eAAe;QACf,wBAAwB;QACxB,uBAAuB;QACvB,gBAAgB;QAChB,qBAAqB;IACzB;IACA;QACI,yBAAyB;QACzB,mBAAmB;QACnB,oCAAoC;QACpC,mCAAmC;QACnC,iBAAiB;QACjB,aAAa;QACb,eAAe;QACf,eAAe;QACf,wBAAwB;QACxB,uBAAuB;QACvB,gBAAgB;IACpB;IACA;QACI,qBAAqB;IACzB;IACA;QACI,qBAAqB;IACzB;IACA;QACI,qBAAqB;QACrB,uBAAuB;IAC3B;IACA;QACI,oCAAoC;QACpC,YAAY;QACZ,eAAe;QACf,oCAAoC;QACpC,kBAAkB;QAClB,sBAAsB;QACtB,gBAAgB;IACpB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,cAAc;QACd,uBAAuB;QACvB,gBAAgB;QAChB,QAAQ;QACR,uBAAuB;IAC3B;AACJ;;;AAGA,mBAAmB;;AAEnB;;;IAGI;QACI,mBAAmB;QACnB,sBAAsB;IAC1B;AACJ","sourcesContent":[".interested-course {\n    margin: 0;\n    padding: 0;\n    padding: 10px;\n}\n\n.students-interested-course {\n    margin-inline-end: 10px;\n    display: flex;\n}\n\n.interested-course-form {\n    max-inline-size: 100%;\n    margin: 0px auto;\n    padding: 10px;\n    background-color: #f5f5f5;\n    border-radius: 10px;\n    border: 2px solid black;\n    color: #0e0e0e;\n    font-weight: 400;\n    margin-block-start: 20px;\n    font-size: 1.2rem;\n}\n\n.interested-course-label {\n    margin-block-end: 10px;\n    color: #0e0e0e;\n    font-weight: 400;\n    font-size: 1.4rem;\n}\n\n.interested-course-1 {\n    inline-size: 100%;\n    padding: 8px;\n    margin-block-end: 4px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n}\n\n.interested-course-submit {\n    inline-size: 100%;\n    padding: 4px;\n    background: linear-gradient(135deg, #052659, #5483B3);\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 20px;\n}\n\n.recommendations-container {\n    margin-block-start: 20px;\n    background: linear-gradient(45deg, #3868a3, #21629a, #6a91ae);\n    border: 1px solid #020202;\n    overflow-y: auto;\n    max-block-size: auto;\n    inline-size: auto;\n    border-radius: 10px;\n}\n\n.recommendations-index {\n    margin-block-end: 10px;\n    margin-inline-start: 20px;\n    margin-block-start: 20px;\n    color: white;\n    font-weight: 600;\n    font-size: 1.8rem;\n}\n\n.recommendations-ul {\n    list-style-type: none;\n    padding: 0;\n}\n\n.recommendations-ul a {\n    color: white;\n    text-decoration: none;\n}\n\n.recommendations-ul a:hover {\n    color: rgb(0, 0, 0);\n}\n\n.recommendations-li {\n    margin-block-end: 8px;\n    font-weight: 400;\n    font-size: 25px;\n    text-align: start;\n    margin-inline-start: 10px;\n    margin-block-start: 10px;\n    padding: 2px;\n}\n\n.recommendations-index-flex {\n    display: flex;\n    align-items: center;\n}\n\n.jNeOpF1 {\n    -webkit-box-align: center;\n    align-items: center;\n    background-color: rgb(255, 255, 255);\n    border: 1px solid rgb(32, 226, 215);\n    border-radius: 50%;\n    display: flex;\n    block-size: 25px;\n    font-size: 1.0rem;\n    -webkit-box-pack: center;\n    justify-content: center;\n    inline-size: 25px;\n    margin-block-end: 20px;\n}\n\n.lfeMSB1 {\n    -webkit-box-align: center;\n    align-items: center;\n    background-color: rgb(255, 255, 255);\n    border: 1px solid rgb(32, 226, 215);\n    border-radius: 50%;\n    display: flex;\n    block-size: 25px;\n    font-size: 1.4rem;\n    -webkit-box-pack: center;\n    justify-content: center;\n    inline-size: 25px;\n}\n\n.lfem1 {\n    margin-block-end: 20px;\n}\n\n.lfems1 {\n    margin-block-end: 20px;\n}\n\n.lfems2 {\n    margin-block-end: 20px;\n    margin-block-start: 10px;\n}\n\n.iZEyIQ1 ul li::after {\n    background-color: rgb(204, 204, 204);\n    content: \" \";\n    block-size: 20px;\n    inset-inline-start: calc((45% - 1px));\n    position: absolute;\n    inset-block-start: 25px;\n    inline-size: 3px;\n}\n\n.iZEyIQ1 ul li {\n    position: relative;\n}\n\n.Circle-sc-fvyqwls-1 {\n    font-size: 20px;\n    margin-block-start: 0px;\n    list-style: none;\n    gap: 40px;\n    margin-block-start: 0px;\n}\n\n@media (max-width: 480px) {\n    .students-interested-course {\n        flex-direction: column;\n        margin-inline-end: 10px;\n    }\n    .interested-course-form {\n        max-inline-size: 90%;\n        border-radius: 0px;\n        margin-block-start: 20px;\n    }\n    .interested-course-1 {\n        inline-size: 100%;\n        border-radius: 0px;\n    }\n    .recommendations-container {\n        inline-size: 90%;\n        border-radius: 0px;\n        margin-inline-start: 14px;\n    }\n    .recommendations-index {\n        margin-block-end: 10px;\n        margin-inline-start: 10px;\n        margin-block-start: 20px;\n        font-size: 1.4rem;\n    }\n    .recommendations-li {\n        font-size: 1.2rem;\n        margin-inline-start: -20px;\n    }\n    .recommendations-index-flex {\n        display: flex;\n        align-items: start;\n    }\n    .jNeOpF1 {\n        -webkit-box-align: center;\n        align-items: center;\n        background-color: rgb(255, 255, 255);\n        border: 0px solid rgb(32, 226, 215);\n        border-radius: 0%;\n        display: flex;\n        block-size: 0px;\n        font-size: 0rem;\n        -webkit-box-pack: center;\n        justify-content: center;\n        inline-size: 0px;\n        margin-block-end: 0px;\n    }\n    .lfeMSB1 {\n        -webkit-box-align: center;\n        align-items: center;\n        background-color: rgb(255, 255, 255);\n        border: 0px solid rgb(32, 226, 215);\n        border-radius: 0%;\n        display: flex;\n        block-size: 0px;\n        font-size: 0rem;\n        -webkit-box-pack: center;\n        justify-content: center;\n        inline-size: 0px;\n    }\n    .lfem1 {\n        margin-block-end: 0px;\n    }\n    .lfems1 {\n        margin-block-end: 0px;\n    }\n    .lfems2 {\n        margin-block-end: 0px;\n        margin-block-start: 0px;\n    }\n    .iZEyIQ1 ul li::after {\n        background-color: rgb(204, 204, 204);\n        content: \" \";\n        block-size: 0px;\n        inset-inline-start: calc((0% - 0px));\n        position: absolute;\n        inset-block-start: 0px;\n        inline-size: 0px;\n    }\n    .iZEyIQ1 ul li {\n        position: relative;\n    }\n    .Circle-sc-fvyqwls-1 {\n        font-size: 0px;\n        margin-block-start: 0px;\n        list-style: none;\n        gap: 0px;\n        margin-block-start: 0px;\n    }\n}\n\n\n/* Tablet Styling */\n\n@media (min-width: 481px) and (max-width: 1023px),\n(min-width : 768px) and (max-width : 1023px),\n(min-width : 1024px) and (max-width : 1279px) {\n    .students-interested-course {\n        margin-right : 10px;\n        flex-direction: column;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
